import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ReplaySubject, takeUntil } from 'rxjs';

import { LaunchDarklyFlags } from 'app/core/services/launch-darkly/launch-darkly.types';
import { getFeatureFlagObservable } from 'app/core/state';
import { AppState } from 'app/types';
import { Loggable } from 'app/utils/logging/loggable';

import { socialAppSelectors } from '../../state/app';

@Injectable({
  providedIn: 'root',
})
export class RegionService extends Loggable {
  public recordingRegions: string[] = [];
  public region?: string;
  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor(private store: Store<AppState>) {
    super();
    this.setDisplayName('RegionService');

    this.store
      .select(socialAppSelectors.getRegion)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((region) => {
        this.region = region;
      });

    getFeatureFlagObservable(this.store, LaunchDarklyFlags.social_recording_region)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(({ regions }) => {
        this.recordingRegions = regions;
      });
  }

  public get isRecordingRegionAvailable(): boolean {
    return this.recordingRegions.includes(this.region ?? 'no-region');
  }
}
